<template>
  <div class="layout-container">
    <!-- 左侧菜单栏 -->
    <aside class="sidebar">
      <div class="sidebar-header">
        <img src="../../assets/neb_logo.png" alt="" style="width: 40px;">
        <span class="logo-text">Nebula</span>
      </div>

      <el-menu :default-active="activeMenu" class="sidebar-menu" background-color="#1e3a5f" text-color="#ffffff"
        active-text-color="#409eff" router>
        <el-menu-item index="/management/user">
          <el-icon>
            <User />
          </el-icon>
          <span>用户管理</span>
        </el-menu-item>
        <el-menu-item index="/management/node">
          <el-icon>
            <Document />
          </el-icon>
          <span>节点管理</span>
        </el-menu-item>
        <el-menu-item index="/management/user-node">
          <el-icon>
            <Link />
          </el-icon>
          <span>用户节点</span>
        </el-menu-item>
      </el-menu>
    </aside>

    <!-- 主内容区 -->
    <div class="main-content">
      <!-- 顶部头部 -->
      <header class="header">
        <div class="header-left">
          <el-breadcrumb separator="/" class="breadcrumb">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>{{ currentPageTitle }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="header-right">
          <el-dropdown trigger="click" @command="handleCommand">
            <div class="user-info">
              <el-icon>
                <User />
              </el-icon>
              <span>{{ username }}</span>
              <el-icon>
                <ArrowDown />
              </el-icon>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="logout">
                  <el-icon>
                    <SwitchButton />
                  </el-icon>
                  退出登录
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </header>

      <!-- 页面内容 -->
      <div class="content-wrapper">
        <el-card>
          <router-view />
        </el-card>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed,onMounted,ref} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { User, Document, Link, ArrowDown, SwitchButton } from '@element-plus/icons-vue'
import {getUserInfoApi} from '@/api/url'

const route = useRoute()
const router = useRouter()

const activeMenu = computed(() => route.path)

const currentPageTitle = computed(() => {
  const titleMap = {
    '/management/user': '用户管理',
    '/management/node': '节点管理',
    '/management/user-node': '用户节点'
  }
  return titleMap[route.path] || '首页'
})

const username = ref('admin')
const  getInfo = async () => { 
  await getUserInfoApi().then(res => { 
    username.value = res.data.username
  })
}
onMounted(() => {
     getInfo()
})
// username.value = localStorage.getItem('username')

const handleCommand = (command) => {
  if (command === 'logout') {
   
    localStorage.removeItem('token')
    localStorage.removeItem('refresh_token')
    router.push('/login')
  }
}
</script>

<style lang="scss" scoped>
.layout-container {
  display: flex;
  height: 100vh;
  overflow: hidden;
}

.sidebar {
  width: 220px;
  background-color: #1e3a5f;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}

.sidebar-header {
  height: 64px;
  display: flex;
  align-items: center;
  // justify-content: center;
  padding: 0 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  .logo-text {
    color: #ffffff;
    font-size: 18px;
    font-weight: bold;
    margin-left: 8px;
  }
}

.sidebar-menu {
  flex: 1;
  border: none;

  :deep(.el-menu-item) {
    height: 56px;
    line-height: 56px;

    &.is-active {
      background-color: rgba(64, 158, 255, 0.1) !important;
    }

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }
  }
}

.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: #f5f5f5;
}

.header {
  height: 64px;
  background-color: #ffffff;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  flex-shrink: 0;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 24px;
}

.header-logo {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #1e3a5f;
  font-weight: bold;
  font-size: 16px;
}

.breadcrumb {
  :deep(.el-breadcrumb__inner) {
    color: #606266;
    font-weight: normal;
  }
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.login-status {
  display: flex;
  align-items: center;
  gap: 4px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #606266;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    color: #409eff;
  }
}

.content-wrapper {
  flex: 1;
  overflow: auto;
  padding: 24px;
  background-color: #f5f5f5;
}
</style>
